export default __webpack_public_path__ + "static/qa-security-3ef0dd28ab19a13f5631c9a26caf61ea.png";